import React from "react";
// Importing css file
import "./Footer.css";

const Footer = () => {
  return (
    <div>
      <div className="footer">
        <p>© 2021 FUTURE ACADEMY. All rights reserved</p>
        <p>Helpline : 834955533 (Available : 09:00am to 11:00pm)</p>
      </div>
    </div>
  );
};

export default Footer;
